import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Heading from '../components/Heading'
import ModuleWithLoader from '../components/ModuleWithLoader'
import DataSource from '../DataSource'
import SubHeader from '../components/SubHeader'
import ToggleSimple from '../elements/ToggleSimple'
import LoadingOverlay from '../components/LoadingOverlay'
import globals from '../globals'
import HomeSecureAccountHistory from '../components/HomeSecureAccountHistory'
import { connect } from 'react-redux'

const gaEvents = {
    blockedContentSms: 'HsNotificationBlockedContentSmsToggle',
    blockedContentEmail: 'HsNotificationBlockedContentEmailToggle',
    blockedVirusSms: 'HsNotificationVirusMalwarePhishingSmsToggle',
    blockedVirusEmail: 'HsNotificationVirusMalwarePhishingEmailToggle'
}

const HomeSecureNotifications = (props) => {
    const [isLoaded, setIsLoaded] = useState(false)
    const [hasError, setHasError] = useState(false)

    const [isNotificationsLoading, setIsNotificationsLoading] = useState(false)
    const [hasNotificationError, setHasNotificationError] = useState(false)
    const [notifications, setNotifications] = useState({
        blockedContentSms: false,
        blockedContentEmail: false,
        blockedVirusSms: false,
        blockedVirusEmail: false
    })
    const [timer, setTimer] = useState(setTimeout(() => {}, 0))

    useEffect(() => {
        DataSource.getData(`/api/getNotificationsAndPrivacy/${props.serviceId}`, response => {
            setNotifications(
                {
                    blockedContentSms: Boolean(response.blockedContentSms),
                    blockedContentEmail: Boolean(response.blockedContentEmail),
                    blockedVirusSms: Boolean(response.blockedVirusSms),
                    blockedVirusEmail: Boolean(response.blockedVirusEmail)
                }
            )
            setIsLoaded(true)
        }, () => {
            setHasError(true)
            setIsLoaded(true)
        })
    }, [])

    const toggleNotifications = data => {
        const type = Object.keys(data)[0]
        const value = data[type]

        setNotifications({ ...notifications, ...data })
        globals.pushEvent(`${gaEvents[type]}${value ? 'On' : 'Off'}`)

        clearTimeout(timer)
        setTimer(setTimeout(() => {
            resetErrors()
            setIsNotificationsLoading(true)
            DataSource.postData('/api/postTogglePrivacyNotifications', {
                serviceId: props.serviceId,
                notifications: { ...notifications, ...data }
            }, response => {
                setIsNotificationsLoading(false)
            }, error => {
                setIsNotificationsLoading(false)
                setHasNotificationError(true)
                globals.handleError(error, { info: 'Error trying to update privacy notifications', data: { ...notifications, ...data } })
            })
        }, 1000))
    }

    const resetErrors = () => {
        setHasError(false)
        setHasNotificationError(false)
    }

    const ToggleItem = (type, title) => {
        return (
            <div className='d-flex align-items-center mb-4 justify-content-start'>
                <ToggleSimple
                    value={notifications[type]}
                    handleChange={() => toggleNotifications({ [type]: !notifications[type] })}
                />
                <p className='m-0 ml-3'>{title}</p>
            </div>
        )
    }

    return (
        <div className='module'>
            <Heading title='Notifications & privacy' />
            <ModuleWithLoader isLoaded={isLoaded} hasError={hasError} className='p-4'>
                <div className='row'>
                    <div className='col-12 col-md-8 offset-md-2 text-center'>
                        <SubHeader
                            content='You can manage the type of alerts you would like to receive whenever Home Secure detects an issue. Switch on SMS or email notifications for blocked content or threat protection. Your alert messages will be sent to the email address and/or mobile phone number attached to this My Exetel Account.'
                            className='mb-5'
                        />
                    </div>
                </div>
                <LoadingOverlay isLoading={isNotificationsLoading}>
                    <div className='row mb-5'>
                        <div className='col-12 col-md-4 offset-md-2 d-flex justify-content-center align-items-center text-center text-lg-left mb-4 mb-lg-0'>
                            <div className='d-flex align-items-center flex-column w-100'>
                                <p className='bold m-0 mb-4 font-medium'>Blocked content</p>
                                <div>
                                    {ToggleItem('blockedContentSms', 'SMS notifications')}
                                    {ToggleItem('blockedContentEmail', 'Email notifications')}
                                </div>
                            </div>
                        </div>
                        <div className='col-12 col-md-4 d-flex justify-content-center align-items-center text-center text-lg-left'>
                            <div className='d-flex align-items-center flex-column w-100'>
                                <p className='bold m-0 mb-4 font-medium'>Virus, malware and phishing</p>
                                <div>
                                    {ToggleItem('blockedVirusSms', 'SMS notifications')}
                                    {ToggleItem('blockedVirusEmail', 'Email notifications')}
                                </div>
                            </div>
                        </div>
                        {hasNotificationError ? <div className='col-12 col-md-8 offset-md-2'><div className='row-error mt-3'>Oops. Something went wrong, please try again.</div></div> : ''}
                    </div>
                </LoadingOverlay>

                <div className='row mb-5'>
                    <div className='col-12 col-md-8 offset-md-2 mb-lg-4'>
                        <p className='m-0 mb-4 bold font-medium lh text-center'>Home Secure alerts will be sent to the email and/or<span className='d-none d-lg-inline'><br /></span>mobile phone number attached to your My Exetel account</p>
                        <div className='row'>
                            <div className='col-12 col-lg-6 d-flex justify-content-center mb-4 mb-lg-0'>
                                <div>
                                    <div className='font-small mb-1 text-left'>Email</div>
                                    <input
                                        value={props.email}
                                        onChange={() => {}}
                                        className='bg-lightgrey'
                                        disabled
                                        style={{ width: '270px' }}
                                    />
                                </div>
                            </div>
                            <div className='col-12 col-lg-6 d-flex justify-content-center'>
                                <div>
                                    <div className='font-small mb-1 text-left'>Mobile</div>
                                    <input
                                        value={props.mobile}
                                        onChange={() => {}}
                                        className='bg-lightgrey'
                                        disabled
                                        style={{ width: '270px' }}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row mb-5'>
                    <div className='col-12 col-md-10 offset-md-1 text-center'>
                        <p className='m-0 mb-2 bold font-large'>Privacy protected</p>
                        <p className='m-0'>Home Secure adheres to the highest privacy standards including The Australian Privacy Act (APA 1988) and the European Union General Data Protection Regulation (GDPR 2018). We ensure your personal rights with full access to view, download or delete your historical data. All your data is encrypted via Military Grade Encryption (AES256) and housed in our high security data centres. Read our full Privacy Policy <a href='https://files.exetel.com.au/terms/ExetelPrivacyPolicy.pdf' target='_blank'>here</a>.</p>
                    </div>
                </div>

                <HomeSecureAccountHistory serviceId={props.serviceId} />
            </ModuleWithLoader>
        </div>
    )
}

HomeSecureNotifications.propTypes = {
    serviceId: PropTypes.number.isRequired
}

const mapStateToProps = state => ({
    email: state.auth.contactEmail,
    mobile: state.auth.contactMobile
})

export default connect(mapStateToProps)(HomeSecureNotifications)



// WEBPACK FOOTER //
// ./resources/js/modules/HomeSecureNotifications.js